/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React, { useEffect, useState } from "react";
import { useAuth } from "cms/auth/hooks/useAuth";
import { SimpliCitySDK } from "cms/sdk";
import { RichText } from "@simplicitycms/simplicity-richtext";
import { RichTextImage } from "cms/shared/images/rich-text-image";

const IconCtaComponent = (props) => {

    const component = props?.component;
    const description = component?.description;
    const imageGuid = component?.image;
    const linkGuid = component?.link;
    const title = component?.title;

    const { token } = useAuth();
    const [link, setLink] = useState();

    useEffect(() => {
        const fetchData = async () => {
            if (!link) {
                if (linkGuid) {
                    const _link = await SimpliCitySDK.link.findOne(token, linkGuid);
                    setLink(_link);
                }
            }
        };
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="icon-cta-wrapper">

            {imageGuid && (
                <div className='icon-cta-image-wrapper'>
                    <RichTextImage image={imageGuid} />
                </div>
            )}

            <div className='icon-cta-text-wrapper'>
                {title && <h2>{title}</h2>}
                {description && <RichText richtext={description} />}
            </div>

            {link &&
                <div className='icon-cta-link-wrapper'>
                    <a href={link?.url}>
                        {link?.text}
                    </a>
                </div>
            }

        </div>
    );
};

IconCtaComponent.displayName = "IconCtaComponent";
export { IconCtaComponent };
